import { useEffect, useState } from "react";
import { VinoDataOffer } from "../../types/vino-data-types";
import { isEqual } from "lodash";
import styled from "styled-components";
import {
  Box,
  FlexGrid,
  Heading,
  Section,
  Stack,
  Row,
  Col,
  Text,
} from "@vinomofo/components";
import vinoFetch from "../../utils/vinoFetch";
import { RelatedOffersList } from "./RelatedOffersList";

interface RelatedDefaultItemsProps {
  heading?: string;
  backgroundColor?: string;
  limit?: number;
  isShoppingCartPage?: boolean;
}

const StyledSection = styled(Section)<{ backgroundColor?: string }>`
  background-color: #fff;
  padding-bottom: 40px;
  > div > div > div {
    overflow: inherit;
  }

  @media (max-width: 1160px) {
    background-color: ${({ backgroundColor }) =>
      backgroundColor ? backgroundColor : "#fff"};
  }
`;

export const RelatedDefaultItems = ({
  heading,
  backgroundColor,
  limit = 4,
  isShoppingCartPage = false,
}: RelatedDefaultItemsProps): JSX.Element => {
  const [isLoading, setIsLoading] = useState(true);
  const [recommendedOffers, setRecommendedOffers] = useState<VinoDataOffer[]>(
    []
  );

  useEffect(() => {
    const fetchDefaultRelatedOffers = async () => {
      setIsLoading(true);
      try {
        const params = new URLSearchParams({
          market: process.env.GATSBY_VM_MARKET || "AU",
        });
        const url = `/api/get-default-related-offers?${params.toString()}`;
        const response = await vinoFetch.get(url);

        if (!isEqual(recommendedOffers, response.data)) {
          setRecommendedOffers(response.data);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching default offers:", error);
      }
    };

    fetchDefaultRelatedOffers();
  }, []);

  const renderContent = () => (
    <FlexGrid
      gutter={1}
      display={isShoppingCartPage ? ["none", "block"] : ["block"]}
    >
      {heading && !isShoppingCartPage && (
        <Stack space={2}>
          <Heading as="h3" variant="lg" textAlign="center">
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              padding={["40px"]}
            >
              {heading}
            </Box>
          </Heading>
        </Stack>
      )}
      {heading && isShoppingCartPage && (
        <Row
          backgroundColor="almostWhite"
          borderBottom="1px solid"
          borderColor="divider"
          padding="20px"
        >
          <Col size={24}>
            <Text fontSize="14px" color="dorianGray" fontWeight={500}>
              {heading}
            </Text>
          </Col>
        </Row>
      )}
      {isShoppingCartPage && <Row padding="3px"></Row>}
      <RelatedOffersList
        backgroundColor={backgroundColor}
        recommendedOffers={recommendedOffers}
        isLoading={isLoading}
        isShoppingCartPage={isShoppingCartPage}
        engine="default"
        limit={limit}
        columns={limit}
      />
    </FlexGrid>
  );

  return isShoppingCartPage ? (
    <Box backgroundColor="white" pt={0} pb={["0px"]} width="100%">
      {renderContent()}
    </Box>
  ) : (
    <StyledSection backgroundColor={backgroundColor}>
      {renderContent()}
    </StyledSection>
  );
};
